export const FormTitleParam = [
  { route: "room", title: "Property and guests" },
  { route: "amenities", title: "Amenities" },
  { route: "location", title: "Location" },
  { route: "description", title: "Description and title" },
  { route: "title", title: "Description and title" },
  { route: "price", title: "Description and title" },
  { route: "bedrooms", title: "Property and guests" },
]
